import React, { useState } from 'react';
import { Row, Col, Card, Button, Icon } from 'antd';
import Layouts from '../../components/Layouts';
import apiRequest from '../../hooks/ApiRequest';
import { useParams } from 'react-router-dom';

const SubscribePage = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { policyId } = useParams();

    const handleSubscribe = async () => {
        setLoading(true);
        setError('');
        try {
            // debugger
            const res = await apiRequest(process.env.REACT_APP_BASE_URL + `/api/PaypalWebhook/subscribe/${policyId}`, 'GET');
            const { approval_url } = res.data;
            window.location.href = approval_url;
        } catch (err) {
            console.error("Subscription error:", err);
            setError("Unable to start subscription. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layouts title="Auto Payment Subscription" classname="dashboard">
            <div className="dash-bg-white">
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={12}>
                        <h3 style={{ color: '#0C1362', fontWeight: 600, fontSize: 20 }}>
                            Enable Monthly Auto-Pay
                        </h3>
                    </Col>
                </Row>
            </div>

            <div className="dash-bg-white">
                <Card
                    bordered={false}
                    title={
                        <span style={{ fontSize: '20px', fontWeight: '600', color: '#0C1362' }}>
                            Monthly Policy Auto-Pay Setup
                        </span>
                    }
                >
                    <Row justify="center" align="middle" type="flex" style={{ textAlign: 'center' }}>
                        <Col span={24}>
                            <Icon type="credit-card" style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
                            <p style={{ fontSize: 16 }}>
                                You've successfully made your policy payment.
                            </p>
                            <p style={{ fontSize: 16 }}>
                                To ensure uninterrupted coverage, we recommend setting up automatic monthly deductions.
                            </p>
                            {error && (
                                <p style={{ color: 'red', marginTop: 12 }}>{error}</p>
                            )}
                            <Button
                                type="primary"
                                onClick={handleSubscribe}
                                loading={loading}
                                style={{ marginTop: 24 }}
                            >
                                {loading ? 'Redirecting to PayPal...' : 'Subscribe for Auto-Pay'}
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        </Layouts>
    );
};

export default SubscribePage;
